<template>
  <h6 class="mb-1">{{ order }}) {{ freeField1 }}</h6>
  <p>{{ freeField2 }}</p>
  <div class="d-flex">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="btn btn-link text-muted"
      :class="{ selected: Number(value) === option.value }"
      :title="option.label"
      @click="setValue(option.value)"
    >
      <i class="ph ph-star ph-3x" :class="starColor(option.value)" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'StartIconsScale',

  props: {
    order: {
      type: [String, Number],
      default: '1',
    },
    freeField1: {
      type: String,
      default: 'Qual é sua avaliação',
    },
    freeField2: {
      type: String,
      default: '',
    },
    freeField3: {
      type: String,
      default: '',
    },
    userDistribution: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      options: [
        { value: 1, label: '1 Estrela' },
        { value: 2, label: '2 Estrelas' },
        { value: 3, label: '3 Estrelas' },
        { value: 4, label: '4 Estrelas' },
        { value: 5, label: '5 Estrelas' },
      ],
      value: '',
    }
  },

  emits: ['setValue'],

  methods: {
    setValue(value) {
      if (this.userDistribution) {
        const newUserDistribution = { ...this.userDistribution }
        newUserDistribution.value = value
        this.$emit('setValue', newUserDistribution)
      }
      this.value = value
    },

    starColor(value) {
      return {
        'text-yellow': this.value >= Number(value),
      }
    },
  },

  mounted() {
    if (this.userDistribution) {
      this.value = this.userDistribution.value
    }
  },
}
</script>
